module.exports = __webpack_public_path__ + "static/media/puchero.33cb549c.png";